import { AbstractConfDataCommand } from "./abstractConfDataCommand";
import { IFileUpload } from "./iFileUpload";

export class AttachmentCommand extends AbstractConfDataCommand {
  attachmentId?: number;
  add?: IFileUpload;
  delete?: boolean;

  // CUSTOM
  typeId?: number;
}